// extracted by mini-css-extract-plugin
export default {"customScrollbar":"CommonLayout_customScrollbar__kXome"};